<template>
    <div class="whats-next mb-0">
        <carousel
            :margin="15"
            :touchDrag="true"
            :pullDrag="true"
            :nav="true"
            :rewind="true"
            :center="false"
            :responsive="{
            0: {
              items: 1,
              nav:false,
              dots: true,
            },
            576: {
              items: 2,
              nav:false,
              dots: true,
            },
            991: {
              items: 3,
              nav:false,
              dots: true,
            },
            1192: {
              items: 4,
              autoplay: false,
              loop: true,
              dots: false,
              nav:true,
            }
          }"
        >
            <!-- <div v-for="(card, index) in nextEvents" :key="index">
        <md-card>
          <md-card-header>
            <div class="md-title">{{card.type}}</div>
          </md-card-header>
          <md-card-content>
            <div class="date">{{card.date}}</div>
            <div class="title">{{card.title}}</div>
            <div class="location">
              <i class="material-icons">{{card.location === "online" ? 'wifi_tethering' : 'location_on'}}</i>
              <a href="#">{{card.location}}</a>
            </div>
          </md-card-content>
        </md-card>
            </div>-->
            <!-- 1 -->
            <md-card md-with-hover>
                <a href="#">
                    <md-card-header>
                        <div class="header-bg">Wednesday, June 5, 2019</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="title">Progressive Web App Meetup #AperiTech di DotNetCode</div>
                        <div class="location d-flex mt-2">
                            <i class="material-icons">location_on</i>
                            <div>Rome</div>
                        </div>
                    </md-card-content>
                </a>
            </md-card>
            <!-- 2 -->
            <md-card md-with-hover>
                <a href="#">
                    <md-card-header>
                        <div class="header-bg">Wednesday, June 5, 2019</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="title">Progressive Web App Meetup #AperiTech di DotNetCode</div>
                        <div class="location d-flex mt-2">
                            <i class="material-icons">location_on</i>
                            <div>Rome</div>
                        </div>
                    </md-card-content>
                </a>
            </md-card>
            <!-- 3 -->
            <md-card md-with-hover>
                <a href="#">
                    <md-card-header>
                        <div class="header-bg">Wednesday, June 5, 2019</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="title">Progressive Web App Meetup #AperiTech di DotNetCode</div>
                        <div class="location d-flex mt-2">
                            <i class="material-icons">location_on</i>
                            <div>Rome</div>
                        </div>
                    </md-card-content>
                </a>
            </md-card>
            <!-- 4 -->
            <md-card md-with-hover>
                <a href="#">
                    <md-card-header>
                        <div class="header-bg">Wednesday, June 5, 2019</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="title">Progressive Web App Meetup #AperiTech di DotNetCode</div>
                        <div class="location d-flex mt-2">
                            <i class="material-icons">location_on</i>
                            <div>Rome</div>
                        </div>
                    </md-card-content>
                </a>
            </md-card>
            <!-- 5-->
            <md-card md-with-hover>
                <a href="#">
                    <md-card-header>
                        <div class="header-bg">Wednesday, June 5, 2019</div>
                    </md-card-header>
                    <md-card-content>
                        <div class="title">Progressive Web App Meetup #AperiTech di DotNetCode</div>
                        <div class="location d-flex mt-2">
                            <i class="material-icons">location_on</i>
                            <div>Rome</div>
                        </div>
                    </md-card-content>
                </a>
            </md-card>
        </carousel>
    </div>
</template>

<script>
import carousel from "v-owl-carousel";

export default {
    name: "WhatsNext",
    props: ["nextEvents"],
    components: {
        carousel
    }
};
</script>

<style lang="scss">
@import "@/assets/scss/_common.scss";
.whats-next {
    * {
        color: $palette-blue;
    }
    max-width: 100%;
    margin: auto;
    background: white;
    text-align: center;
    padding: 15px;

    .owl-carousel {
        display: flex;
        flex-direction: column;

        .owl-stage {
            height: 100%;
            display: flex;
            align-items: stretch;
        }
        .owl-item {
            display: flex;
            justify-content: center;
            margin-bottom: 20px;
        }
        .owl-dots {
            margin-top: 0 !important;
            .owl-dot span {
                width: 7px;
                height: 7px;
                margin: 5px 4px;
            }
        }
    }

    .md-card {
        background: #ffffff;
        border: 1px solid #dcdcdc;
        border-radius: 5px;
        height: 100%;
        min-width: 265px;
        -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
            0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
        border-radius: 5px;
        .md-card-content {
            position: relative;
            height: 100%;
        }
        .md-card-content {
            text-align: left;
            display: flex;
            flex-direction: column;
            padding: 0.6rem 1rem;
            .date {
                font-size: 14px;
            }
            .title {
                font-weight: 700;
                font-size: 16px;
                color: $palette-blue;
                max-height: 44px;
                overflow: hidden;
            }
            .location {
                font-size: 14px;
                justify-items: center;
                align-items: center;
                i {
                    color: $palette-blue;
                    font-size: 14px;
                    vertical-align: text-top;
                }

                div {
                    font-weight: 500;
                }
            }
        }
    }

    .header-bg {
        background-color: $palette-blue;
        padding: 0.6rem 1rem;
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        border-radius: 5px 5px 0 0;
        text-align: left;
    }

    .md-card-header {
        padding: 0;
    }

    .owl-nav {
        margin-top: 0;
        .owl-prev,
        .owl-next {
            width: 30px;
            height: 30px;
            border-radius: 50% !important;
            background: white !important;
            box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5);
            position: absolute;
            top: 34%;
            display: block !important;

            span {
                display: none;
            }
        }
        .owl-prev {
            left: -25px;
            padding: 4px 7px;
            outline: 0;
            &:after {
                font-family: "Material Icons";
                content: "chevron_left";
                font-size: 20px;
            }
        }

        .owl-next {
            right: -25px;
            padding: 4px 7px;
            outline: 0;
            &:after {
                font-family: "Material Icons";
                content: "chevron_right";
                font-size: 20px;
            }
        }
    }

    .owl-theme .owl-nav [class*="owl-"]:hover {
        color: $palette-blue;
        text-decoration: none;
    }
}
</style>
